import { Component, Container } from 'bitmovin-player-ui';

export default new Container({
    id: 'custom-seekbar-wrapper',
    cssClasses: ['ui-seekbar'],
    components: [
        new Container({
            id: 'custom-seekbar-track',
            cssClasses: ['seekbar'],
            components: [
                new Container({
                    cssClasses: ['seekbar-backdrop'],
                }),
                new Container({
                    cssClasses: ['seekbar-bufferlevel'],
                }),
                new Container({
                    cssClasses: ['seekbar-seekposition'],
                }),
                new Container({
                    cssClasses: ['seekbar-playbackposition'],
                }),
                new Container({
                    cssClasses: ['seekbar-markers'],
                }),
                new Container({
                    cssClasses: ['seekbar-playbackposition-marker'],
                }),
            ],
        }),
        new Container({
            cssClasses: ['ui-seekbar-label'],
            components: [
                new Container({
                    cssClasses: ['seekbar-label-inner'],
                    components: [
                        new Component({
                            cssClasses: ['seekbar-thumbnail'],
                            role: 'img',
                        }),
                    ],
                }),
                new Container({
                    tag: 'span',
                    cssClasses: ['seekbar-label-caret'],
                    role: 'timer',
                }),
            ],
        }),
    ],
});
